<template>
  <common-dialog ref="dialog" width="720px" title="手工录入订单" id-key="id" form-label-width="110px" :data="data"
    @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved @closed="onClosed">
    <template slot="form">
      <template v-if="!data.isPrint">
        <el-form-item label="订单号（选填）">
          <div style="display: flex;">
            <el-input style="width: calc(100% - 80px);" v-model="data.orderSn"
              placeholder="输入订单号，点击“自动关联”，会自动填充收件人信息"></el-input>
            <el-button type="primary" style="margin-left: 10px;" @click="onLink">自动关联</el-button>
          </div>
        </el-form-item>
        <el-form-item label="智能地址识别">
          <div style="display: flex;">
            <el-input type="textarea" style="width: calc(100% - 80px);" v-model="identification"
              placeholder="请按照“姓名 电话 地址”顺序粘贴或填写，中间需要用空格隔开，如：张三 15000000000 上海市长宁区茅台路1010号3-5"></el-input>
            <el-button type="primary" style="margin-left: 10px;width: 80px;height: 28px;"
              @click="onIdentification">识别</el-button>
          </div>
        </el-form-item>
      </template>
      <el-form-item label="收件人" prop="receiverAddress.fullName">
        <el-input v-model="data.receiverAddress.fullName" :disabled="data.type==20" placeholder="请输入收件人"></el-input>
      </el-form-item>
      <el-form-item label="省市区" prop="addressCode">
        <address-select style="width: 100%;" v-model="data.addressCode" :disabled="data.type==20" :placeholder="'请选择城市'"
          @change="onAddressSelect" />
      </el-form-item>
      <el-form-item label="详细地址" prop="receiverAddress.detailAddress">
        <el-input v-model="data.receiverAddress.detailAddress" :disabled="data.type==20"
          placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="receiverAddress.mobilePhone">
        <el-input v-model="data.receiverAddress.mobilePhone" :disabled="data.type==20" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <template v-if="!data.isPrint">
        <el-form-item label="商品信息" prop="goodsName">
          <el-input v-model="data.goodsName" placeholder="请输入商品信息"></el-input>
        </el-form-item>
        <el-form-item label="商品数量" prop="goodsCount">
          <el-input v-model="data.goodsCount" placeholder="请输入商品数量"></el-input>
        </el-form-item>
        <el-form-item label="重量（kg）" prop="goodsWeight">
          <el-input v-model="data.goodsWeight" placeholder="请输入重量"></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="note">
          <el-input v-model="data.note" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </template>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <template v-if="!data.isPrint">
        <el-button type="primary" @click="saveAndPrint">保存并打印</el-button>
        <el-button type="primary" @click="saveAndCreate">保存并继续创建</el-button>
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '../mixins/editDialog'; //部分相同的逻辑使用代码混入

export default {
  mixins: [editDialogMixin],
  data() {
    return {
      orderApi: require("@/api/ali/order").default,
      data: this.$platformJs.getPddObj('freeprint.editDialog'),
      rules: {
        'receiverAddress.fullName': [{ required: true, message: '收件人不能为空' }],
        addressCode: [{ required: true, message: '请选择省市区' }],
        'receiverAddress.detailAddress': [{ required: true, message: '详细地址不能为空' }],
        'receiverAddress.mobilePhone': [{ required: true, message: '联系方式不能为空' }],
      },
    };
  },
  methods: {
    onCreateOpened() {

    },
    onEditOpened(data) {
      console.log("onEditOpened1", JSON.parse(JSON.stringify(data)));
      console.log("onEditOpened2", JSON.parse(JSON.stringify(this.data)));
      var x = data.receiverAddress;
      var addressName = x.province + x.city + x.district;
      if (addressName) this.data.addressCode = this.getAddressCodeByName(addressName);
    },
    onLink() {
      if (!this.data.orderSn) {
        this.$message.warning("请输入订单号");
        return;
      }
      this.orderApi.getBySn(this.data.orderSn, this.mallToken).then(res => {
        if (!res.errorCode) {
          this.data.type = 20; // 关联
          this.data.receiverAddress.fullName = res.receiverAddress.fullName;
          this.data.receiverAddress.mobilePhone = res.receiverAddress.mobilePhone;
          this.data.receiverAddress.detailAddress = res.receiverAddress.detailAddress;
          var addressName = res.receiverAddress.province + res.receiverAddress.city + res.receiverAddress.district;
          this.data.addressCode = this.getAddressCodeByName(addressName);
        } else {
          this.$message.error(res.errorMessage);
        }
      }).catch(err => { })
      console.log("关联");
    },
    onIdentification() {
      if (!this.identification) {
        this.$message.warning("请输入要识别的内容");
        return;
      }
      if (this.data.type == 20) {
        this.$message.warning("关联订单不能修改地址信息");
        return;
      }
      console.log("识别");
      const info = smart(this.identification);
      console.log(info);
      this.data.addressCode = info.provinceCode + "/" + info.cityCode + "/" + info.countyCode;

      this.data.receiverAddress.province = info.province;
      this.data.receiverAddress.city = info.city;
      this.data.receiverAddress.district = info.county;

      this.data.receiverAddress.fullName = info.name;
      this.data.receiverAddress.mobilePhone = info.phone;
      if (info.street) this.data.receiverAddress.detailAddress = info.street + info.address
      else this.data.receiverAddress.detailAddress = info.address;
    },
    onAddressSelect(e) {
      // this.data.省市区文本 = e.map(x => x.label).join("/");
      console.log("省市区", e);
      console.log("addressCode", this.data.addressCode);

      this.data.receiverAddress.province = e[0].label;
      this.data.receiverAddress.city = e[1].label;
      this.data.receiverAddress.district = e[2].label;
    },
    onSave() {
      return new Promise((resolve, reject) => {
        var func = this.orderApi.postManual;
        if (this.data.id != 0) func = this.orderApi.putManual;
        func(this.data, this.mallToken).then(res => {
          if (res) {
            resolve({ Code: 1, Msg: res.errorMessage })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        }).catch(err => { })
      })
    },
  },
};
</script>
